import { Toaster as RhtToaster, toast as rhtToast, type ToastOptions } from 'react-hot-toast';

const baseOptions: ToastOptions = {
  duration: 4000,
  style: {
    background: 'var(--bg-surface)',
    color: 'var(--ink-primary)',
    border: '1px solid var(--border)',
    borderRadius: '8px',
    fontSize: '13px',
    padding: '10px 12px',
    boxShadow: 'var(--shadow-md)',
  },
};

export const toast = {
  success: (message: string, options?: ToastOptions) =>
    rhtToast.success(message, {
      ...baseOptions,
      iconTheme: { primary: 'var(--accent)', secondary: 'var(--accent-contrast)' },
      ...options,
    }),
  error: (message: string, options?: ToastOptions) =>
    rhtToast.error(message, {
      ...baseOptions,
      iconTheme: { primary: 'var(--danger)', secondary: 'var(--danger-contrast)' },
      ...options,
    }),
  info: (message: string, options?: ToastOptions) =>
    rhtToast(message, { ...baseOptions, ...options }),
  dismiss: rhtToast.dismiss,
};

export function Toaster() {
  return <RhtToaster position="top-right" gutter={8} toastOptions={baseOptions} />;
}
